//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { BModal } from 'bootstrap-vue'

export default {

    components:  { BModal },

    props: {
        modalId: {
            type: String,
            default: 'search-inquiry'
        },
        inquiryType: {
            type: String,
            default: 'rfp'
        },
        destinationId: {
        }
    },

    data() {
        return {
            inquiryFavlistId: 0,
            countries: {},
            reference: '',
            step: 'start',
            contact: {
                company: '',
                phoneNumber: '',
                firstName: '',
                lastName: '',
                jobTitle: '',
                country: '',
                email: '',
                emailConfirm: '',
            },
            general: {
                description: '',
                fileDocument: null,
            },
            project: {
                destinationPitch: '',
                destinationDescription: '',
                dateStart: '',
                dateEnd: '',
                duration: '',
                amountGuest: '',
                budget: '',
                accommodationRequired: '',
                travelOfAttendees: '',
                projectType: '',
                projectName: '',
                specialRequirements: '',
                activities: '',
                fileDocument: null,
            }
        }
    },

    methods: {

        onStep(step) {
            this.step = step

            if(step === 'successful') {
                this.resetData()
            }
        },


        resetData() {

            this.reference = ''

            let _this = this

            Object.keys(this.contact).forEach(function(key) {
                _this.contact[key] = ''
            });

            Object.keys(this.general).forEach(function(key) {
                _this.general[key] = ''
            });

            Object.keys(this.project).forEach(function(key) {
                _this.project[key] = ''
            });

        },

        showModal: function () {
            this.$refs.modalInquiry.show()
        },

        hideModal: function () {
            this.$refs.modalInquiry.hide()
        },

        onHide: function() {
            //this.$emit('modal-hide')
        },

        hideModalClick: function (reset = false) {
            if(this.$refs.modalInquiry) {
                this.$refs.modalInquiry.hide()

                if(reset) {
                    this.resetData()
                }

            }
        },

        onHidden: function () {
            this.step = 'start'
        },

        onShow: function () {

            if(this.$helper.isEmpty(this.countries)) {
                this.getCountries()
            }

            if(this.reference == '') {
                this.getReference()
            }
        },

        getCountries: async function () {

            try {
                const response = await this.$axios.$get(this.route('api.content.countries.data'))
                this.countries = response

            } catch (e) {
                this.$logger.captureException(e)
            }

        },

        getReference: async function () {

            try {
                const responseRef = await this.$axios.$get(this.route('search.inquiry.newreference'))
                this.reference = responseRef.reference

            } catch (e) {
                this.$logger.captureException(e)
            }

        }

    },

    computed: {

        headerText() {

            if(this.step === 'successful') {
                return 'THANK YOU FOR YOUR REQUEST!'
            } else {
                return 'CREATE YOUR REQUEST'
            }

        },

    }

}

